import { GridColDef } from "@mui/x-data-grid";
import { AppTable } from "components/molecules";
import { TableHelper } from "helpers";
import { ILoadingOrderProduct } from "model/LoadingOrder/ILoadingOrderProduct";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { LoadingOrderActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";
import { translations, I18nTranslator } from "utils/i18n";
import { Typography } from "@mui/material";
import moment from "moment";

interface IProductListProps {
  deliveryOrderHeaderId: string;
}
const ProductList = (props: IProductListProps) => {
  const { deliveryOrderHeaderId } = props;
  const dispatch = useDispatch();
  const data = useAppSelector(
    (state) => state.LoadingOrderReducer.product.data!
  );

  const headerAction = useAppSelector(
    (state) => state.LoadingOrderReducer.action
  );
  const action = useAppSelector(
    (state) => state.LoadingOrderReducer.product.action
  );

  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    _getAllLoadingOrder();
  }, [
    searchText,
    headerAction.includes(
      LoadingOrderActions.importLoadingOrderDocument.successName
    ),
  ]);

  const _getAllLoadingOrder = (pageNumber = 1) => {
    dispatch(
      LoadingOrderActions.getAllLoadingOrderProducts.request({
        pageNumber: pageNumber,
        pageSize: 100,
        deliveryOrderHeaderId: deliveryOrderHeaderId,
        searchText: searchText,
      })
    );
  };

  const _handlePageSizeChange = (pageSize: number) => {
    dispatch(
      LoadingOrderActions.getAllLoadingOrderProducts.request({
        pageNumber: 1,
        pageSize: pageSize,
        deliveryOrderHeaderId: deliveryOrderHeaderId,
        searchText: searchText,
      })
    );
  };

  const COLUMNS: GridColDef[] = [
    TableHelper.renderSTT(),
    TableHelper.createCell({
      field: "delivery",
      headerName: I18nTranslator(translations.receive.deliveryOrderId),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "companyName",
      headerName: I18nTranslator(translations.receive.companyName),
      size: "full",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "provinceSoldTo",
      headerName: I18nTranslator(translations.receive.address),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "provinceShipTo",
      headerName: I18nTranslator(translations.receive.shipToAddress),
      size: "medium",
      align: "left",
    }),
    TableHelper.createCell({
      field: "companyCode",
      headerName: I18nTranslator(translations.receive.companyId),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "productCode",
      headerName: I18nTranslator(translations.receive.productId),
      size: "small",
      align: "left",
      sortable: true,
    }),

    TableHelper.createCell({
      field: "productDescription",
      headerName: I18nTranslator(translations.receive.productName),
      size: "medium",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "batchCode",
      headerName: I18nTranslator(translations.receive.batchCode),
      size: "small",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "uom",
      headerName: I18nTranslator(translations.receive.uom),
      size: 100,
      align: "center",
    }),
    TableHelper.createCell({
      field: "quantity",
      headerName: I18nTranslator(translations.receive.quantity),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "deliveryDate",
      headerName: I18nTranslator(translations.receive.deliveryDate),
      size: "small",
      align: "left",
      sortable: true,
      renderCell: ({ value }) => (
        <Typography>{moment(value).format("DD/MM/YYYY")}</Typography>
      ),
    }),
    TableHelper.createCell({
      field: "batchCodeDistributor",
      headerName: I18nTranslator(translations.receive.vendorBatchCode),
      size: "medium",
      align: "left",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "netWeight",
      headerName: I18nTranslator(translations.receive.netWeight),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "totalWeight",
      headerName: I18nTranslator(translations.receive.totalWeight),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "volume",
      headerName: I18nTranslator(translations.receive.volume),
      size: "small",
      align: "right",
      sortable: true,
    }),
    TableHelper.createCell({
      field: "volumeUnit",
      headerName: I18nTranslator(translations.receive.volumeUnit),
      size: "small",
      align: "left",
    }),
    TableHelper.createCell({
      field: "productCodeOld",
      headerName: I18nTranslator(translations.receive.productCodeOld),
      size: "small",
      align: "left",
      sortable: true,
    }),
  ];

  return (
    <AppTable<ILoadingOrderProduct>
      loading={action.includes(
        LoadingOrderActions.getAllLoadingOrderProducts.requestName
      )}
      data={data}
      columns={COLUMNS}
      hideAddNew
      onSearch={setSearchText}
      searchPlaceholder={I18nTranslator(
        translations.placeholder.searchLoadingOrderProduct
      )}
      onChangePage={(pageNumber: number) => _getAllLoadingOrder(pageNumber)}
      removeActionColumn
      hideHeader
      defaultHeaderTable={230}
      onPageSizeChange={_handlePageSizeChange}
    />
  );
};

export default ProductList;
